import React, { ReactNode } from 'react';

import { APSProductsType } from './themes/aps';
import { defaultReckonTheme } from './themes/reckon';
import { ThemeDecorator } from './themes/ThemeDecorator';
import { Themes } from './themes/themes';
import { Tenancy } from './themes/types';

type LayoutProps = {
  children: ReactNode;
  theme: Tenancy;
  product?: APSProductsType;
  hideFooter?: boolean;
};

export const Layout = ({
  children,
  theme,
  product,
  hideFooter,
}: LayoutProps) => {
  const selectedTheme =
    Themes.find((t) => t.tenant === theme && t.product === product) ||
    Themes.find((t) => t.tenant === theme && t.product === 'default') ||
    defaultReckonTheme;

  return (
    <ThemeDecorator
      backgroundColor={selectedTheme.baseTheme.backgroundColor}
      headerLogo={selectedTheme.productTheme.headerLogo}
      textColor={selectedTheme.baseTheme.textColor}
      textLinkColor={selectedTheme.baseTheme.textLinkColor}
      leftBackgroundImage={selectedTheme.productTheme.leftBackgroundImage}
      rightBackgroundImage={selectedTheme.productTheme.rightBackgroundImage}
      footerDescription={selectedTheme.productTheme.footerDescription}
      hideFooter={hideFooter}
    >
      {children}
    </ThemeDecorator>
  );
};
